import { useState, useRef, useEffect } from 'react';
import { Button } from 'reactstrap';
import GenericChart from './GenericChart';
import CreateAnalyticsChart from './CreateAnalyticsChart';
import GridLayout from 'react-grid-layout';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import CreateAnalyticsPage from './CreateAnalyticsPage';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAnalyticsDetails } from '../../actions/analytics';

const Analytics = () => {
  document.title = 'Analytics';
  const gridContainerRef = useRef(null);

  const { pageId } = useParams();

  const { analyticsPages } = useSelector((state) => state?.analytics);
  const [pageDetails, setPageDetails] = useState(null);

  console.log(pageDetails, 'pageDetails');
  console.log(analyticsPages, 'analyticsPages');
  console.log(pageId, 'pageId');

  const [isLoading, setIsLoading] = useState(false);
  const [layout, setLayout] = useState([]);

  useEffect(() => {
    try {
      getAnalyticsDetailsFunc();
    } catch (e) {
      console.log(e);
    }
  }, [analyticsPages, pageId]);

  const getAnalyticsDetailsFunc = async () => {
    try {
      const input = { pageId: pageId };

      const res = await getAnalyticsDetails(input);

      if (res?.pageId) {
        setPageDetails(res);
      } else {
        setPageDetails(null);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleLayoutChange = (newLayout) => {
    setLayout(newLayout);
  };

  const handleAddLayout = () => {
    const newKey = (layout.length + 1).toString();
    setLayout([
      ...layout,
      {
        i: newKey,
        x: 0,
        y: Infinity,
        w: 12,
        h: 10,
      },
    ]);
  };

  // console.log('layouts', layout);

  const handleDeleteLayout = (key) => {
    setLayout(layout.filter((item) => item.i !== key));
  };

  return (
    <div className="page-content px-4 pb-4">
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div className="row d-flex flex-row flex-wrap"></div>
        <div className="col-12 d-flex flex-row justify-content-between mb-3">
          <div>
            <h4 className="mb-0">Analytics</h4>
          </div>
          <div className="d-flex flex-row gap-3">
            <CreateAnalyticsPage />
            <CreateAnalyticsChart
              pageId={pageId}
              submitHandler={() => getAnalyticsDetailsFunc()}
            />
            {/* <Button color="primary" className="ms-2" onClick={handleAddLayout}>
              Add Layout
            </Button> */}
          </div>
        </div>
        <div
          className="col-12"
          style={{ backgroundColor: '#e0e0e0', flex: 1, minHeight: 600 }}
          ref={gridContainerRef}
        >
          <GridLayout
            className="layout"
            layout={pageDetails?.layout}
            cols={12}
            rowHeight={30}
            width={gridContainerRef.current?.offsetWidth || 1200}
            onLayoutChange={handleLayoutChange}
            draggableHandle=".drag-handle"
          >
            {pageDetails?.layout?.map((item, index) => {
              const chart = pageDetails?.charts?.find(
                (c) => c?.layoutId === item?.i
              );

              return (
                <div key={item.i}>
                  <div
                    className="card h-100"
                    style={{ minWidth: '200px', minHeight: 200 }}
                  >
                    <div className="card-header d-flex justify-content-between align-items-center">
                      <span
                        className="drag-handle"
                        style={{
                          cursor: 'grab',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <i
                          className="bx bx-move me-1"
                          style={{ fontSize: '1.2rem' }}
                        ></i>
                      </span>
                      <span className="text-truncate font-bold">
                        {chart?.title || 'Untitled Chart'}
                      </span>

                      <div className="d-flex flex-row align-items-center">
                        <CreateAnalyticsChart
                          pageId={pageId}
                          submitHandler={() => getAnalyticsDetailsFunc()}
                          chart={chart}
                        />
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-1 ms-2 shadow-none"
                          onClick={() => handleDeleteLayout(item.i)}
                          title="Delete"
                        >
                          <i
                            className="bx bx-trash text-danger"
                            style={{ fontSize: '1rem' }}
                          ></i>
                        </button>
                      </div>
                    </div>
                    <div className="card-body">
                      <GenericChart
                        options={chart?.option}
                        // options={{
                        //   title: {
                        //     text: 'Total Discount Over Time',
                        //     left: 'center',
                        //   },
                        //   tooltip: {
                        //     trigger: 'axis',
                        //   },
                        //   xAxis: {
                        //     type: 'category',
                        //     data: chart?.data?.map((item) => item.date),
                        //     axisLabel: {
                        //       rotate: 45,
                        //     },
                        //   },
                        //   yAxis: {
                        //     type: 'value',
                        //     name: 'Total Discount',
                        //   },
                        //   series: [
                        //     {
                        //       name: 'Discount',
                        //       type: 'line',
                        //       data: chart?.data?.map(
                        //         (item) => item.totalDiscount
                        //       ),
                        //       smooth: true,
                        //       lineStyle: {
                        //         color: '#5470C6',
                        //       },
                        //       itemStyle: {
                        //         color: '#5470C6',
                        //       },
                        //     },
                        //   ],
                        // }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </GridLayout>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
